import { isRequired, isEmail, isValidLength } from 'utils/validators';

const COMPANY_NAME_MIN_LENGTH = 2;

const validate = values => {
  const errors = {};

  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email, 'Incorrect email value')) {
    errors.email = 'Incorrect email value';
  }

  if (isRequired(values.phoneNumber || '', true)) {
    errors.phoneNumber = 'Phone is required';
  }
  if (isRequired(values.companyName || '', true)) {
    errors.companyName = 'Company name is required';
  } else if (
    !isValidLength(values.companyName, COMPANY_NAME_MIN_LENGTH, true)
  ) {
    errors.companyName = 'The Company name should contain at least 3 symbols';
  }

  return errors;
};

export default validate;
